// Complete endpoint inventory: docs/api/ENDPOINTS.md (npm run api:catalog).

const rootAPI = process.env.REACT_APP_API_ENDPOINT;

const API = {
  offlineProspects: `${rootAPI}/api/basic/v2.0.0/crm/offline-prospects`,
  activityLogs: `${rootAPI}/api/activity-logs`,
  auth: {
    login: `${rootAPI}/api/auth/login`,
    signUp: `${rootAPI}/api/auth/signup`,
    user: `${rootAPI}/api/auth/users`,
    register: `${rootAPI}/api/auth/users/register`,
  },
  conversations: `${rootAPI}/api/conversations`,
  create_app: `${rootAPI}/api/app/create/new`,
  get_app_data: `${rootAPI}/api/app/get-app`,
  app_update: `${rootAPI}/api/app/update`,
  third_party_api: `${rootAPI}/api/third-party/connect`,
  access_control: `${rootAPI}/api/access-control/users`,
  instruction: `${rootAPI}/api/instruction`,
  product: `${rootAPI}/api/product`,
  connect: `${rootAPI}/api/connect`,
  fields: `${rootAPI}/api/fields`,
  images: `${rootAPI}/uploads/images`,
  product_order: `${rootAPI}/api/products/orders`,
  payment: `${rootAPI}/api/payment`,
  packages: `${rootAPI}/api/packages`,
  coupon: `${rootAPI}/api/coupons`,
  facebook:`${rootAPI}/api`,
  messages: `${rootAPI}/api/conversations/messages`,
  campaign: `${rootAPI}/api/whatsapp/campaign`,
};

export { API, rootAPI };

